import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom'
import { KeyboardDatePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, FormControl, Snackbar, InputLabel, Select, InputAdornment } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import CloseImage from '../../assets/ic_close.png';
import line from '../../assets/line grey.png';
import SlotWaktu from './slotWaktu';
import api from '../api'
import MuiAlert from '@material-ui/lab/Alert';
import format from 'date-fns/format';
import { SignalCellularNullSharp, TramRounded } from '@material-ui/icons';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EditJadwalDokter(props) {
    const history = useHistory()
    const location = useLocation()
    // console.log(location);
    // const data = location.state.data[0]
    const id = location.state.id
    // console.log(id);
    const polyclinic = []
    // const detailSLot = location.state.sentData[0].detail
    // const polyclinic = location.state.polyclinic 
    const [popUpRuangan, setPopUpRuangan] = React.useState(false)
    const [visibleTimeslot, setVisibleTimeslot] = React.useState(false)
    const [visibleBatal, setVisibleBatal] = React.useState(false)
    const [openAlert, setOpenAlert] = React.useState(false);
    const [visibleStatus, setVisibleStatus] = React.useState(false)
    const [cancelled, setCancelled] = React.useState(false)
    const [slotWaktu, setSlotWaktu] = React.useState([])
    const [catatan, setCatatan] = React.useState("")
    const [internalNotes, setInternalNotes] = React.useState("")
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [data, setData] = React.useState([])
    // console.log(data);
    let jumlahReservasi = 0
    const forceUpdate = React.useReducer(bool => !bool)[1];
    // let timeMinutes = `${data.time !== "-" || data.time !== null ? `${data.time} Menit` : "-"} `
    let timeMinutes = data.length > 0 ? `${data.time} Menit` : "-"
    const time = timeMinutes === "null Menit" ? "-" : timeMinutes
    const {
        time_start,
        time_end,
        time_type,
        // time: timeMinutes,
        quota,
        quota_bpjs,
        service_type,
        room,
    } = data
    const [timeEnd, setTimeEnd] = React.useState(null)
    const [tanggal, setTanggal] = React.useState(data.schedule_date)
    const [timeStart, setTimeStart] = React.useState(null)
    const [timeSlot, setTimeSlot] = React.useState(null)
    const [timeType, setTimeType] = React.useState(null)
    const [waktu, setWaktu] = React.useState('-')
    const [durasi, setDurasi] = React.useState('-')
    const [serviceType, setServiceType] = React.useState(null)
    const [ruangan, setRuangan] = React.useState(data.room)
    const [list_room, set_list_room] = React.useState(null)
    const [gantiRuangan, setGantiRuangan] = React.useState(false)
    const [count_reservation, set_count_reservation] = React.useState(null)
    const [duration, setDuration] = React.useState(null)
    const [notesDokter, setNotesDokter] = React.useState(null)
    const [alasanBatal, setAlasanBatal] = React.useState("")
    const [kuotaPasien, setKuotaPasien] = React.useState(quota)
    const [kuotaBPJS, setKuotaBPJS] = React.useState(null)
    const [notToday, setNotToday] = React.useState(false)

    const [jamSelesai, setJamSelesai] = React.useState(null)
    const [jamMulai, setJamMulai] = React.useState(null)
    const [slotChange, setSlotChange] = React.useState(null)

    const [errorRuangan, setErrorRuangan] = React.useState(false)
    const [texterrorRuangan, setTextErrorRuangan] = React.useState(false)

    const [visibleStop, setVisibleStop] = React.useState(false)
    const [visibleNotes, setVisibleNotes] = React.useState(false)
    const [is_batal, set_is_batal] = React.useState(false)

    const [dokterRuangan, setDokterRuangan] = useState(null)
    const [idDokterRuangan, setIDDokterRuangan] = useState(null)
    const [roomGanti, setRoomGanti] = useState(null)

    const [createdAt, setCreatedAt] = React.useState(null)
    const [createdBy, setCreatedBy] = React.useState(null)
    const [updatedAt, setUpdatedAt] = React.useState(null)
    const [updatedBy, setUpdatedBy] = React.useState(null)
    const [deletedAt, setDeletedAt] = React.useState(null)
    const [deletedBy, setDeletedBy] = React.useState(null)

    React.useEffect(() => {
        console.log(location);
        getRoom()
        getData(id)
        getDetailWaktu()
    }, [])

    const handleClose = () => {
        setOpenAlert(false)
    }

    const getRoom = () => {
        api.create().getRoomFilter("activeinactive=1").then(response => {
            let listRoom = []
            response.data.data.map((el, idx) => {
                listRoom.push({
                    id: el.id,
                    name: `Gd. ${el.building_name}, Lantai.${el.floor}, Ruangan ${el.name}`
                })
            })
            set_list_room(listRoom)
        })
    }

    const getDetailWaktu = () => {
        api.create().getTimeslotDokter(id).then(response => {
            console.log(response);
            if (response.data.data) {
                if (response.data.data.length > 0) {
                    setSlotWaktu(response.data.data[0].detail)
                }
            }
        })
    }

    React.useEffect(() => {
        console.log(data);
        let indexEnd = listJam.findIndex((val) => val.name === time_end)
        let indexStart = listJam.findIndex((val) => val.name === time_start)
        if (duration) {
            let indexSlot = listSlotWaktu.findIndex((val) => val.name === duration)
            setTimeSlot(listSlotWaktu[indexSlot])
        }
        if (time_type !== undefined) {
            let indexTypeQueue = listTypeQueue.findIndex((val) => val.name === time_type)
            setTimeType(listTypeQueue[indexTypeQueue])
        }
        if (list_room) {
            let indexRoom = list_room.findIndex((val) => val.name === room)
            // console.log(indexRoom);
            setRuangan(list_room[indexRoom])
        }
        // console.log(time);
        // if (time) {
        //     let indexTime = listTime.findIndex((val) => val.name == time)
        //     setWaktu(listTime[indexTime])
        // }
        // if (slotWaktu) {
        //     let count = 0;
        //     slotWaktu.map(el => {
        //         console.log(el)
        //         if (el.is_available === 0) {
        //             count++
        //         }
        //     })
        //     set_count_reservation(count)
        // }
        setCreatedBy(data.created_by)
        setCreatedAt(data.created_at)
        setUpdatedBy(data.updated_by)
        setUpdatedAt(data.updated_at)
        setDeletedBy(data.deleted_by)
        setDeletedAt(data.deleted_at)
        setKuotaBPJS(data.quota_bpjs)
        setKuotaPasien(data.quota)
        setInternalNotes(data.internal_notes)
        setTanggal(data.schedule_date)
        setTimeEnd(listJam[indexEnd])
        setTimeStart(listJam[indexStart])
        setNotesDokter(data.doctor_notes)
        setDuration(`${listJam[indexStart]} - ${listJam[indexEnd]}`)
        if (service_type !== undefined) {
            let indexServiceType = listServiceType.findIndex((val) => val.name === service_type)
            setServiceType(listServiceType[indexServiceType])
        }
        forceUpdate()
    }, [list_room, data])

    // console.log(ruangan);

    const getData = (id) => {
        api.create().getTimeslotDokter(id).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    if (response.data.data.length > 0) {
                        let value = response.data.data[0]
                        setData(response.data.data[0])
                        if (value.schedule_date !== `${new Date().getFullYear()}-${new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1}-${new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()}`) {
                            setNotToday(true)
                            setJamSelesai(new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1}-${new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()} ${value.time_end.slice(0, 5)}`))
                            setJamMulai(new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1}-${new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()} ${value.time_start.slice(0, 5)}`))
                            setSlotChange(value.time)
                        }
                        let jumlahReservasi = 0
                        response.data.data[0].detail.map((el, idx) => {
                            if (el.is_available === 0) {
                                jumlahReservasi++
                            }
                        })
                        console.log(value);
                        setWaktu(value.time)
                        setDurasi(value.service_duration)
                        setCatatan(value.remarks)
                        console.log(jumlahReservasi);
                        set_count_reservation(jumlahReservasi)
                        forceUpdate()
                    }
                }
            }
        })
    }

    const listTypeQueue = [
        {
            id: 1,
            name: "TIMESLOT"
        },
        {
            id: 2,
            name: "TIMEBLOK"
        },
        {
            id: 3,
            name: "FIFO"
        },
        {
            id: 4,
            name: "FIFO CHECKIN"
        }
    ]

    const listServiceType = [
        {
            id: 1,
            name: "BPJS"
        },
        {
            id: 2,
            name: "UMUM"
        },
        {
            id: 3,
            name: "BPJS/UMUM"
        },
    ]

    const listTime = [
        {
            id: 0,
            name: time
        },
        {
            id: 1,
            name: '0'
        },
        {
            id: 2,
            name: '10'
        },
        {
            id: 3,
            name: '15'
        },
        {
            id: 4,
            name: '30'
        },
        {
            id: 5,
            name: '45'
        },
    ]

    const listJam = [
        {
            id: 0,
            name: time_start
        },
        {
            id: 0,
            name: time_end
        },
        {
            id: 0,
            name: "07:00:00"
        },
        {
            id: 1,
            name: "08:00:00"
        },
        {
            id: 2,
            name: "09:00:00"
        },
        {
            id: 3,
            name: "11:00:00"
        },
        {
            id: 4,
            name: "12:00:00"
        },
        {
            id: 5,
            name: "13:00:00"
        },
        {
            id: 6,
            name: "14:00:00"
        },
        {
            id: 7,
            name: "15:00:00"
        },
        {
            id: 8,
            name: "16:00:00"
        },
    ]

    let listSlotWaktu = []
    if (timeStart !== null) {
        listSlotWaktu.push(
            { name: `${timeStart.name} - 08:00:00` },
            { name: `${timeStart.name} - 09:00:00` },
            { name: `${timeStart.name} - 10:00:00` },
            { name: `${timeStart.name} - 11:00:00` },
            { name: `${timeStart.name} - 12:00:00` },
            { name: `${timeStart.name} - 13:00:00` },
            { name: `${timeStart.name} - 14:00:00` },
            { name: `${timeStart.name} - 15:00:00` },
            { name: `${timeStart.name} - 16:00:00` },
        )
    }

    // console.log(alasanBatal, '<<');

    const handleTimeSlot = () => {
        setVisibleTimeslot(true)
    }

    const onClose = () => {
        setVisibleTimeslot(false)
        setVisibleStatus(false)
    }

    const handleBatal = () => {
        history.push({
            pathname: "/schedule/jadwal-transaksi-dokter",
            name: "Transaksi Jadwal Dokter",
            state: {
                data: location.state
            }
        })
    }

    const changeStatus = () => {
        let temp;
        const dateNow = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} ${new Date().getHours()}:${new Date().getMinutes() < 10 ? `0${new Date().getMinutes()}` : new Date().getMinutes()}`
        temp = {
            "id": data.id,
            "activeinactive": 0,
            "notes": alasanBatal
        }
        console.log(temp);
        let payload = temp
        console.log(payload);
        api.create().batalTransaksiJadwal(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setVisibleStatus(false)
                    setVisibleBatal(false)
                    setOpenAlert(true)
                    setMessageAlert(response.data.message)
                    setStatusAlert("Succes")
                    // setCancelled(true)
                    getData(data.id)
                    setTimeout(() => {
                        console.log(location.state);
                        history.push({
                            pathname: '/schedule/jadwal-transaksi-dokter',
                            state: {
                                data: location.state
                            }
                        })
                    }, 1000);
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setMessageAlert(response.data.message)
                        setStatusAlert("warning")
                    }
                }
            }
        })
        // let payload 
        // api.create().batalSessionDokter(payload).then(response => {
        //     console.log(response);
        //     if (response) {
        //         if (response.data.data === "Data berhasil di update!") {
        //             setVisibleStatus(false)
        //             setVisibleBatal(false)
        //             setCancelled(true)
        //         } else {
        //             alert("error")
        //         }
        //     }
        // })
    }

    const handleEdit = () => {
        let payload;
        if (gantiRuangan === true) {
            payload = {
                "id": data.id,
                "room_id": ruangan.id,
                "internal_notes": internalNotes,
                "service_type": serviceType && serviceType.id,
                "remarks": catatan
            }
        } else {
            payload = {
                "id": data.id,
                "internal_notes": internalNotes,
                "service_type": serviceType && serviceType.id,
                "remarks": catatan
            }
        }
        console.log(payload);
        api.create().batalTransaksiJadwal(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setOpenAlert(true)
                    setStatusAlert("success")
                    setMessageAlert(response.data.message)
                    getData(id)
                    setTimeout(() => {
                        console.log(location.state);
                        history.push({
                            pathname: '/schedule/jadwal-transaksi-dokter',
                            state: {
                                data: location.state
                            }
                        })
                    }, 1000);
                } else {
                    setPopUpRuangan(true)
                    if (gantiRuangan === true) {
                        api.create().changeRoomSchedule(ruangan.id, format(new Date(tanggal), 'yyyy-MM-dd'), timeStart.name, timeEnd.name).then(response => {
                            console.log(response, list_room);
                            if (response.data) {
                                if (response.data.status === true) {
                                    if (response.data.data.length > 0) {
                                        setDokterRuangan(response.data.data[0].name)
                                        setIDDokterRuangan(response.data.data[0].id)
                                        let idx = list_room.findIndex((val) => val.name === response.data.data[0].room)
                                        if (idx > -1) {
                                            setRoomGanti(list_room[idx])
                                            forceUpdate()
                                        }
                                    }
                                }
                            }
                        })
                    }
                    // setErrorRuangan(true)
                    // setTextErrorRuangan(response.data.data)
                }
            }
        })
    }

    const updateRoomBefore = () => {
        let payload = {
            "id": idDokterRuangan,
            "room_id": roomGanti.id
        }
        api.create().batalTransaksiJadwal(payload).then(response => {
            if (response.data) {
                if (response.data.status === true) {
                    setPopUpRuangan(false)
                    setOpenAlert(true)
                    setStatusAlert("Success")
                    setMessageAlert("Ruangan Berhasil Diganti!")
                } else {
                    if (response.data.data) {
                        setOpenAlert(true)
                        setStatusAlert("warning")
                        setMessageAlert(response.data.message)
                    }
                }
            }
        })
    }

    const handleStop = () => {
        let payload;
        payload = {
            "id": data.id,
            "room_id": ruangan.id,
            "remarks": catatan,
            "internal_notes": internalNotes,
            "is_stop": 1
        }
        api.create().batalTransaksiJadwal(payload).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.message === "Success!") {
                    setOpenAlert(true)
                    setStatusAlert("Data updated!")
                    setMessageAlert(response.data.message)
                    setVisibleStop(false)
                    handleBatal()
                } else {
                    setErrorRuangan(true)
                    setTextErrorRuangan(response.data.data)
                }
            }
            getData(id)
        })
    }

    // console.log(serviceType);
    // console.log(timeType);

    return (
        <div style={{ paddingTop: 20, height: '89vh', overflow: 'auto', }}>
            <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            {
                data.deleted_at !== null ?
                    <div>
                        <Typography style={{ color: '#278863', fontSize: 20, fontWeight: 500, paddingLeft: 30 }}>{data.name}</Typography>
                        <Typography style={{ color: '#a4a4a4', fontSize: 15, fontWeight: 500, paddingLeft: 30 }}>Klinik {data.polyclinic}</Typography>

                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                            <div className="column-1" style={{ width: '80%' }}>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="date"
                                            label="Tanggal"
                                            format="dd/MM/yyyy"
                                            value={tanggal}
                                            disabled={true}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            InputProps={{
                                                disableUnderline: true
                                            }}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                            style={{ width: '100%' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                        label="Jam Selesai"
                                        defaultValue=" "
                                        value={timeEnd && timeEnd.name || data.time_end}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        label="Slot Waktu"
                                        value={waktu === '0' ? '-' : waktu}
                                        placeholder=""
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        label="Durasi Layanan"
                                        value={durasi === null ? '-' : waktu}
                                        placeholder=""
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 7 }}
                                        id="quota"
                                        name="quota"
                                        label="Kuota Pasien"
                                        disabled={true}
                                        // type=""
                                        // required={true}
                                        value={kuotaPasien || "-"}
                                        // onChange={(e) => {
                                        //     setKuotaPasien(e.target.value)
                                        //     // setErrorNoKTP(false)
                                        //     // setTextNoKTP("")
                                        //     forceUpdate()
                                        // }}
                                        inputProps={{
                                            style: {
                                                // fontWeight: 'bold',
                                                color: 'black'
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    {list_room !== undefined ?
                                        <div>
                                            <TextField
                                                style={{ width: '100%', marginTop: 7 }}
                                                id="quota"
                                                name="quota"
                                                label="Ruangan"
                                                disabled={true}
                                                // type=""
                                                // required={true}
                                                value={ruangan && ruangan.name || "-"}
                                                // onChange={(e) => {
                                                //     setKuotaPasien(e.target.value)
                                                //     // setErrorNoKTP(false)
                                                //     // setTextNoKTP("")
                                                //     forceUpdate()
                                                // }}
                                                inputProps={{
                                                    style: {
                                                        // fontWeight: 'bold',
                                                        color: 'black'
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    style: {

                                                        color: '#7e8085',
                                                    }
                                                }}
                                                InputProps={{
                                                    disableUnderline: true
                                                }}
                                            />
                                            <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                        </div>
                                        // <Autocomplete
                                        //         // multiple
                                        //         // style={{marginTop: 20}}
                                        //         options={list_room}
                                        //         getOptionLabel={(option) => option.name}
                                        //         // getOptionSelected={(option) => option.name}
                                        //         // debug
                                        //         name='room'
                                        //         id="room"
                                        //         onChange={(event, newInputValue) => {
                                        //             setRuangan(newInputValue)
                                        //         }}
                                        //         renderInput={(params) =>
                                        //             <TextField
                                        //                 {...params}
                                        //                 InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        //                 InputLabelProps={{ style: { color: '#7e8085' } }}
                                        //                 label="Ruangan"
                                        //             />
                                        //         }
                                        //         value={ruangan}
                                        // />
                                        : null
                                    }
                                </div>

                                <TextField
                                    style={{ width: '100%' }}
                                    label="Catatan Internal"
                                    value={internalNotes}
                                    placeholder={"Input Catatan Internal"}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>

                            <div className="column-2" style={{ width: '80%', marginLeft: '1em' }}>
                                <div className="">
                                    <TextField
                                        label="Jam Mulai"
                                        style={{ marginTop: 24 }}
                                        defaultValue=" "
                                        value={timeStart && timeStart.name || data.time_start}
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="" style={{ marginTop: 7 }}>
                                    <TextField
                                        value={timeType && timeType.name}
                                        disabled={true}
                                        defaultValue=" "
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                        label="Tipe Antrian"
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 0, cursor: 'pointer' }}
                                        id="time"
                                        name="time"
                                        label="Detai Slot Waktu"
                                        type=""
                                        // required={true}
                                        value={"Lihat Detail"}
                                        onClick={() => handleTimeSlot()}
                                        onChange={(e) => {
                                            // setNOKTP(e.target.value)
                                            // setErrorNoKTP(false)
                                            // setTextNoKTP("")
                                            // forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ marginTop: 7 }}
                                        label="Opsi Pembayaran"
                                        value={serviceType && serviceType.name}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        defaultValue=" "
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>

                                <TextField
                                    style={{ width: '100%' }}
                                    label="Catatan Publik"
                                    value={catatan}
                                    placeholder={"Input Catatan Publik"}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />

                                {visibleTimeslot ?
                                    <SlotWaktu
                                        onClose={onClose}
                                        duration={{ start: timeStart, end: timeEnd }}
                                        dataApi={data.detail}
                                    />
                                    : null
                                }
                            </div>
                        </div>
                        <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18, marginTop: 30, marginLeft: 30 }}>Status</Typography>
                        <div className="grid grid-3x grid-mobile-none gap-15px" style={{ padding: '20px 50px', paddingLeft: 50, margin: 'auto' }}>
                            <div className="column-1">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Created By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{createdBy === null ? "-" : createdBy === "" ? "-" : createdBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Created at</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{createdAt === null ? "-" : createdAt === "" ? "-" : createdAt}</Typography>
                            </div>
                            <div className="column-2">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Updated By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{updatedBy === null ? "-" : updatedBy === "" ? "-" : updatedBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Updated At</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{updatedAt === null ? "-" : updatedAt === "" ? "-" : updatedAt}</Typography>
                            </div>
                            <div className="column-3">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Deleted By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{deletedBy === null ? "-" : deletedBy === "" ? "-" : deletedBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Deleted At</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{deletedAt === null ? "-" : deletedAt === "" ? "-" : deletedAt}</Typography>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50, }}>
                            <img src={line} style={{ width: '187%' }} />
                            <div className="column-1" >
                                <TextField
                                    label="Alasan Pembatalan Sesi"
                                    multiline
                                    style={{ width: '100%' }}
                                    value={data.notes || '-'}
                                    disabled={true}
                                    InputProps={{
                                        disableUnderline: true
                                    }}
                                    inputProps={{
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            width: 300
                                        }
                                    }}
                                />
                                <img src={line} style={{ width: '187%', marginTop: -20 }} />
                            </div>
                        </div>
                        {
                            data.deleted_at === null ?
                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: 50, marginTop: 150 }}>
                                    <div onClick={() => handleBatal()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                        <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                    </div>
                                    <div onClick={(e) => null} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                        <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, marginLeft: 50 }}>Simpan</Typography>
                                    </div>
                                </div>
                                : null
                        }
                        {visibleStatus && (
                            <div className="App app-popup-show">
                                <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                    <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                        <div className="col-1" />
                                        <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                            <button
                                                type="button"
                                                className="btn btn-circle btn-white"
                                                onClick={() => onClose}
                                            >
                                                <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                            </button>
                                        </div>
                                    </div>
                                    <div style={{ padding: 20 }}>
                                        <Typography style={{ textAlign: 'left', fontSize: 16 }}>Ada {count_reservation} Reservasi di Session ini, Anda yakin ingin membatalkan session ini? </Typography>
                                    </div>
                                    <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                        <div className="column-1" style={{ alignSelf: 'center' }}>
                                        </div>
                                        <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            <div
                                                onClick={() => onClose()}
                                                style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                                <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                            </div>
                                            <div
                                                onClick={() => changeStatus()}
                                                style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    :
                    <div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ paddingRight: 30, paddingLeft: 30 }}>
                            <div className="column-1" style={{ width: '80%' }}>
                                <Typography style={{ color: '#278863', fontSize: 20, fontWeight: 500, }}>{data.name}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontSize: 15, fontWeight: 500, }}>Klinik {data.polyclinic}</Typography>
                            </div>
                            <div className="column-2" style={{}}>
                                <TextField
                                    style={{ width: '100%' }}
                                    disabled={true}
                                    multiline
                                    maxRows={2}
                                    rows={2}
                                    InputProps={{
                                        disableUnderline: true,
                                        style: {
                                            color: 'black'
                                        }
                                    }}
                                    inputProps={{
                                        style: {
                                            letterSpacing: 1.5, color: '#a4a4a4', fontSize: 14
                                        }
                                    }}
                                    value={notesDokter}
                                />
                                {notesDokter && notesDokter.length > 20 && (
                                    <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', cursor: 'pointer' }}
                                        onClick={() => {
                                            setVisibleNotes(true)
                                        }}
                                    >
                                        <Typography style={{ color: '#37a7ed', fontSize: 12 }}>Lihat Detail</Typography>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                            <div className="column-1" style={{ width: '80%' }}>
                                <div className="">
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            margin="normal"
                                            disabled={true}
                                            id="date"
                                            label="Tanggal"
                                            format="dd/MM/yyyy"
                                            value={tanggal}
                                            onChange={(date) => {
                                                setTanggal(date)
                                                // setTglLahir(date)
                                                forceUpdate()
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            InputProps={{
                                                disableUnderline: true
                                            }}
                                            inputProps={{
                                                style: {
                                                    color: 'black'
                                                }
                                            }}
                                            style={{ width: '100%' }}
                                        />
                                    </MuiPickersUtilsProvider>
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ marginTop: 10 }}
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                        label="Jam Selesai"
                                        value={timeEnd.name}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ marginTop: 10 }}
                                        label="Slot Waktu"
                                        placeholder=""
                                        value={waktu === 0 ? '-' : waktu}
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ marginTop: 10 }}
                                        label="Durasi Layanan"
                                        placeholder=""
                                        value={durasi === 0 ? '-' : durasi}
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 10 }}
                                        id="quota"
                                        name="quota"
                                        label="Kuota Pasien"
                                        disabled={true}
                                        // type=""
                                        // required={true}
                                        value={kuotaPasien || "-"}
                                        // onChange={(e) => {
                                        //     setKuotaPasien(e.target.value)
                                        //     // setErrorNoKTP(false)
                                        //     // setTextNoKTP("")
                                        //     forceUpdate()
                                        // }}
                                        inputProps={{
                                            style: {
                                                // fontWeight: 'bold',
                                                color: 'black'
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 7 }}
                                        id="quota"
                                        name="quota"
                                        label="Kuota BPJS"
                                        disabled={true}
                                        value={kuotaBPJS || "-"}
                                        // onChange={(e) => {
                                        //     setKuotaPasien(e.target.value)
                                        //     // setErrorNoKTP(false)
                                        //     // setTextNoKTP("")
                                        //     forceUpdate()
                                        // }}
                                        inputProps={{
                                            style: {
                                                // fontWeight: 'bold',
                                                color: 'black'
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    {list_room !== null ?
                                        <Autocomplete
                                            // multiple
                                            style={{ marginTop: 10 }}
                                            options={list_room}
                                            getOptionLabel={(option) => option.name}
                                            disabled={!location.state.update}
                                            name='room'
                                            id="room"
                                            onChange={(event, newInputValue) => {
                                                setRuangan(newInputValue)
                                                setGantiRuangan(true)
                                                setErrorRuangan(false)
                                                setTextErrorRuangan(null)
                                                forceUpdate()
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    {...params}
                                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                                    label="Ruangan"
                                                    error={errorRuangan}
                                                    helperText={texterrorRuangan}
                                                />
                                            }
                                            value={ruangan || " "}
                                        />
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="column-2" style={{ width: '80%', marginLeft: '1em' }}>
                                <div className="">
                                    <TextField
                                        label="Jam Mulai"
                                        style={{ marginTop: 25 }}
                                        value={timeStart.name}
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="" style={{ marginTop: -9 }}>
                                    <TextField
                                        style={{ marginTop: 16 }}
                                        value={timeType && timeType.name}
                                        disabled={true}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                        label="Tipe Antrian"
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} />
                                </div>
                                <div className="">
                                    <TextField
                                        style={{ width: '100%', marginTop: 13, cursor: 'pointer' }}
                                        id="time"
                                        name="time"
                                        label="Detai Slot Waktu"
                                        type=""
                                        // required={true}
                                        value={"Lihat Detail"}
                                        onClick={() => handleTimeSlot()}
                                        onChange={(e) => {
                                            // setNOKTP(e.target.value)
                                            // setErrorNoKTP(false)
                                            // setTextNoKTP("")
                                            // forceUpdate()
                                        }}
                                        inputProps={{
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        }}
                                        InputLabelProps={{
                                            style: {

                                                color: '#7e8085',
                                            }
                                        }}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -35 }} />
                                </div>
                                <div className="">
                                    {/* <TextField
                                        style={{ marginTop: 13 }}
                                        label="Opsi Pembayaran"
                                        value={serviceType && serviceType.name}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        inputProps={{
                                            style: {
                                                color: 'black'
                                            }
                                        }}
                                    />
                                    <img src={line} style={{ width: '100%', marginTop: -30 }} /> */}
                                    <Autocomplete
                                        // multiple
                                        options={listServiceType}
                                        style={{ marginTop: 15, width: '100%', marginBottom: 22 }}
                                        getOptionLabel={(option) => option.name}
                                        getOptionDisabled={(option) =>
                                            data.service_type === "UMUM" && option.id === 1 ||
                                            data.service_type === "BPJS" && option.id === 2 ||
                                            data.service_type === "BPJS/UMUM" && option.id === 1 ||
                                            data.service_type === "BPJS/UMUM" && option.id === 2
                                        }
                                        value={serviceType}
                                        onChange={(event, newInputValue) => {
                                            setServiceType(newInputValue)
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, style: { fontSize: 13 }, }}
                                                InputLabelProps={{ style: { color: '#7e8085' } }}
                                                label="Opsi Pembayaran"
                                            />
                                        }
                                    />
                                </div>

                                <TextField
                                    style={{ width: '100%' }}
                                    label="Catatan Publik"
                                    value={catatan}
                                    placeholder={"Input Catatan Publik"}
                                    onChange={(e) => {
                                        setCatatan(e.target.value)
                                    }}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />

                                <TextField
                                    style={{ width: '100%', marginTop: 29 }}
                                    label="Catatan Internal"
                                    value={internalNotes}
                                    placeholder={"Input Catatan Internal"}
                                    onChange={(e) => {
                                        setInternalNotes(e.target.value)
                                    }}
                                    inputProps={{
                                        style: {
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {

                                            color: '#7e8085',
                                        }
                                    }}
                                />

                                {visibleTimeslot ?
                                    <SlotWaktu
                                        onClose={onClose}
                                        duration={{ start: timeStart, end: timeEnd }}
                                        dataApi={data.detail}
                                    />
                                    : null
                                }
                            </div>
                        </div>
                        <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 18, marginTop: 30, marginLeft: 30 }}>Status</Typography>
                        <div className="grid grid-3x grid-mobile-none gap-15px" style={{ padding: '20px 50px', paddingLeft: 50, margin: 'auto' }}>
                            <div className="column-1">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Created By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{createdBy === null ? "-" : createdBy === "" ? "-" : createdBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Created at</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{createdAt === null ? "-" : createdAt === "" ? "-" : createdAt}</Typography>
                            </div>
                            <div className="column-2">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Updated By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{updatedBy === null ? "-" : updatedBy === "" ? "-" : updatedBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Updated At</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{updatedAt === null ? "-" : updatedAt === "" ? "-" : updatedAt}</Typography>
                            </div>
                            <div className="column-3">
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10 }}>Deleted By</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{deletedBy === null ? "-" : deletedBy === "" ? "-" : deletedBy}</Typography>
                                <Typography style={{ color: '#a4a4a4', fontFamily: 'Poppins', fontWeight: '300', fontSize: 10, marginTop: 15 }}>Deleted At</Typography>
                                <Typography style={{ color: '#000000', fontFamily: 'Poppins', fontWeight: '500', fontSize: 11 }}>{deletedAt === null ? "-" : deletedAt === "" ? "-" : deletedAt}</Typography>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                            {location.state.update && (
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 110, marginBottom: 10, width: '187%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                                        <div onClick={() => set_is_batal(true)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', marginRight: 20 }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlignLast: 'center' }}>Batal Sesi</Typography>
                                        </div>
                                        <div onClick={() => setVisibleStop(true)} style={{ height: 32, width: 150, backgroundColor: '#f54257', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlignLast: 'center' }}>Tutup Reservasi</Typography>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginRight: 10 }}>
                                        <div onClick={() => handleBatal()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5, textAlignLast: 'center' }}>Kembali</Typography>
                                        </div>
                                        <div onClick={(e) => handleEdit()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', marginLeft: 15 }} >
                                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5, textAlignLast: 'center' }}>Simpan</Typography>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {
                            is_batal &&
                            (
                                <div className="App app-popup-show">
                                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                            <div className="col-1" style={{ width: 400 }} >
                                                <Typography style={{ width: 180, height: 20, textAlign: 'center', padding: 0, alignSelf: 'center', marginTop: 17, whiteSpace: 'nowrap' }}>Alasan Pembatalan Sesi</Typography>
                                            </div>
                                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                                <button
                                                    type="button"
                                                    className="btn btn-circle btn-white"
                                                    onClick={() => set_is_batal(false)}
                                                >
                                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                                </button>
                                            </div>
                                        </div>
                                        <div style={{ padding: 20 }}>
                                            <textarea
                                                type="text"
                                                style={{ width: '90%', height: '20vh', textAlignLast: 'start' }}
                                                value={alasanBatal}
                                                onChange={(e) => setAlasanBatal(e.target.value)}
                                            />
                                            <Typography style={{ color: 'red', fontSize: 13, fontWeight: '500' }}>Note: Sudah ada {count_reservation} Reservasi Pasien di Session ini</Typography>
                                        </div>
                                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                            <div className="column-1" style={{ alignSelf: 'center' }}>
                                            </div>
                                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                <div
                                                    onClick={() => changeStatus()}
                                                    style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Kirim</Typography>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {visibleStatus && (
                            <div className="App app-popup-show">
                                <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                    <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                        <div className="col-1" />
                                        <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                            <button
                                                type="button"
                                                className="btn btn-circle btn-white"
                                                onClick={() => setVisibleStatus(false)}
                                            >
                                                <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                            </button>
                                        </div>
                                    </div>
                                    <div style={{ padding: 20 }}>
                                        <Typography style={{ textAlign: 'left', fontSize: 16 }}>Ada {count_reservation} Reservasi di Session ini, Anda yakin ingin membatalkan session ini? </Typography>
                                    </div>
                                    <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                        <div className="column-1" style={{ alignSelf: 'center' }}>
                                        </div>
                                        <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            <div
                                                onClick={() => onClose()}
                                                style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                                <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                            </div>
                                            <div
                                                onClick={() => changeStatus()}
                                                style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {visibleStop && (
                            <div className="App app-popup-show">
                                <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                    <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                        <div className="col-1" />
                                        <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                            <button
                                                type="button"
                                                className="btn btn-circle btn-white"
                                                onClick={() => setVisibleStop(false)}
                                            >
                                                <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                            </button>
                                        </div>
                                    </div>
                                    <div style={{ padding: 20 }}>
                                        <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda yakin ingin menghentikan reservasi dokter tersebut? </Typography>
                                    </div>
                                    <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                        <div className="column-1" style={{ alignSelf: 'center' }}>
                                        </div>
                                        <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            <div
                                                onClick={() => setVisibleStop(false)}
                                                style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                                <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                            </div>
                                            <div
                                                onClick={() => handleStop()}
                                                style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {visibleNotes && (
                            <div className="App app-popup-show">
                                <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                                    <div style={{ padding: 20 }}>
                                        <textarea
                                            value={notesDokter}
                                            disabled
                                            style={{ width: '100%', marginTop: 10, minHeight: 400 }}
                                        />
                                    </div>
                                    <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                        <div className="column-1" style={{ alignSelf: 'center' }}>
                                        </div>
                                        <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            <div
                                                onClick={() => setVisibleNotes(false)}
                                                style={{ height: 28, width: 100, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                                <Typography style={{ color: 'white', fontSize: 13 }}>Tutup</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
            }

            {popUpRuangan && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 800 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <Typography style={{ textAlign: 'left', fontSize: 16, whiteSpace: 'nowrap' }}>Ruangan sudah digunakan</Typography>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setPopUpRuangan(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: '20px 20px 20px' }}>
                            <div className="column-1">
                                <TextField
                                    style={{ width: '80%' }}
                                    label="Dokter"
                                    disabled
                                    value={dokterRuangan ? dokterRuangan : "-"}
                                    inputProps={{
                                        style: {
                                            fontSize: 14,
                                            color: 'black'
                                        }
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontSize: 14,
                                            color: '#7e8085',
                                        }
                                    }}
                                />
                            </div>
                            <div className="column-2">
                                <Autocomplete
                                    options={list_room}
                                    getOptionLabel={(option) => option.name}
                                    id="tipe"
                                    disableClearable
                                    onChange={(event, newInputValue) => {
                                        setRoomGanti(newInputValue)
                                    }}
                                    value={roomGanti}
                                    style={{ width: '80%' }}
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                            label="Ruangan"
                                        />
                                    }
                                />
                            </div>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setPopUpRuangan(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => updateRoomBefore()}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}